/**
 * Pricing Analysis (PEL) reducer — classic switch reducer, matching the style of
 * src/reducers/benchmarkingReducer.js. Register it in src/reducers/index.js:
 *
 *   import pricingAnalysis from './pricingAnalysisReducer';
 *   combineReducers({ ..., pricingAnalysis });
 *
 * Then read it in a connected component:
 *   const mapStateToProps = (state) => ({ pel: state.pricingAnalysis });
 */
import {
  PEL_FETCH_DASHBOARD, PEL_FETCH_MAP, PEL_FETCH_LEVEL, PEL_FETCH_GROWTH,
  PEL_FETCH_CTS_LTV, PEL_FETCH_BENCHMARKING, PEL_FETCH_AI_INSIGHTS,
  PEL_FETCH_CLIENTS, PEL_RUN_SIMULATION, PEL_SET_ERROR,
} from '../actions/pricingAnalysisTypes';

const initialState = {
  dashboard: null,
  map: null,
  levels: {},          // { level0: {...}, level1: {...}, ... }
  growthModel: null,
  ctsLtv: null,
  benchmarking: null,
  aiInsights: null,
  clientPortfolio: null,
  simulation: null,
  error: null,
};

export default function pricingAnalysisReducer(state = initialState, action) {
  switch (action.type) {
    case PEL_FETCH_DASHBOARD:
      return { ...state, dashboard: action.payload };
    case PEL_FETCH_MAP:
      return { ...state, map: action.payload };
    case PEL_FETCH_LEVEL:
      return { ...state, levels: { ...state.levels, [action.payload.level]: action.payload.data } };
    case PEL_FETCH_GROWTH:
      return { ...state, growthModel: action.payload };
    case PEL_FETCH_CTS_LTV:
      return { ...state, ctsLtv: action.payload };
    case PEL_FETCH_BENCHMARKING:
      return { ...state, benchmarking: action.payload };
    case PEL_FETCH_AI_INSIGHTS:
      return { ...state, aiInsights: action.payload };
    case PEL_FETCH_CLIENTS:
      return { ...state, clientPortfolio: action.payload };
    case PEL_RUN_SIMULATION:
      return { ...state, simulation: action.payload };
    case PEL_SET_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
